import ServerSettings from "../../../gd/settings/server-settings/server-settings";

const fieldsConfig = {


    'ignoreWeekends': {
        type            : 'value',
        defaultValue    : true,
    },

    // if set to false ignore other values and do not do auto scheduling
    'autoScheduling': {
        type            : 'value',
        defaultValue    : true,
    },

    // 0 = same day; 1=next work day; *used in finish->start only
    'defaultLag': {
        type            : 'value',
        defaultValue    : 1,
    },

    // if true deal with dependencies...
    'dependencies': {
        type            : 'value',
        defaultValue    : true,
    },

    // if true keep lag by dafulat shift = ignore
    'dependenciesKeepLag': {
        type            : 'value',
        defaultValue    : true,
    },

    // movse subtasks if change parent task (like start-start)
    'taskSubtask': {
        type            : 'value',
        defaultValue    : true,
    },

    // automatically - not implemented ... if move subtask auto update main task
    'subtaskTask': {
        type            : 'value',
        defaultValue    : true,
    },

    // move project children on project change (based on start-start)
    'projectChildren': {
        type            : 'value',
        defaultValue    : true,
    },

    // update (increase) project when move children inside
    'childProject': {
        type            : 'value',
        defaultValue    : true,
    },

    // reschedule project events
    'projectEvents': {
        type            : 'value',
        defaultValue    : true,
    },

    // reschedule project milestones
    'projectMilestones': {
        type            : 'value',
        defaultValue    : true,
    }

}

export default class UserSettingsViewsGantt extends ServerSettings {

    [key:string]: any

    constructor(config: any) {

        super(config, fieldsConfig);

        // auto init all settings
        _.forEach(fieldsConfig, (value,key)=>{
            this[key] = this.initValue(key)
        })
    }


    toJson() {
        const result = {};

        // auto save all settings
        _.forEach(fieldsConfig, (value,key)=>{
            this.valueToJson(result, key)
        })

        return result;
    }
}
